<template>

    <div class="absolute w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
        <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 28rem;">

            <span class="border-b border-theme-discrete"><p class="text-lg text-theme-title font-bold mb-2">{{ translate('playlists-mylist') }} - Admin.</p></span>

            <playlist-admin-item :currentlocale="currentlocale" :playlists="playlists"></playlist-admin-item>

            <div class="py-2">
                <input v-model="newPlaylistName" type="text" :placeholder="translate('playlist-enter-new')" class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-2 px-2 focus:outline-none rounded-md" />
            </div>

            <div>

                <button class="text-base bg-theme-controls1 hover:bg-theme-controls3 text-theme-control-label hover:text-theme-control-label rounded-lg px-4 w-32 h-10" @click="createNewPlaylist">
                    {{ translate('create') }}
                </button>

                <button class="text-base bg-theme-controls1 hover:bg-theme-controls3 text-theme-control-label hover:text-theme-control-label rounded-lg px-4 w-32 h-10" @click="dismissPlaylistsAdmin">
                    {{ translate('close') }}
                </button>

            </div>

        </div>
    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [

            'currentlocale',
            'user_id'

        ],

        data() {

            return {

                playlists: '',
                newPlaylistName: ''

            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            dismissPlaylistsAdmin() {

                this.$root.shared.playlistAdminVisible = false
                window.location.reload()

            },

            createNewPlaylist() {

                axios.get('/' + this.currentlocale + '/playlists/create/' + this.user_id + '/' + this.newPlaylistName)
                    .then((response) => {
                        this.playlists.push(response.data)
                        this.newPlaylistName = null
                    })
                    .catch((error) => {
                        console.log('ERROR trying to Create New Playlist ' + this.newPlaylistName + ': ' + error)
                    })
            }

        },

        created() {

            axios.get('/' + this.currentlocale + '/playlists/' + this.user_id)
                .then((response) => {
                    this.playlists = response.data
                })
                .catch((error) => {
                    console.log('ERROR trying to get User ID ' + this.user_id + ' Playlists: ' + error)
                })

        }

    }

</script>
